var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoodTshirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000046336355906125538460000016504537327790926489_);}\n\t.st1{fill:#3B55E6;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1014",
    transform: "translate(38.881 36.76)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -31.02,
    y: -29.71,
    width: 104.28,
    height: 105.91
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026145957413838632410000014805737272140977823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1013",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000026145957413838632410000014805737272140977823_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_395",
    className: "st1",
    d: "M-8.61,61.33h-17.76c-2.57,0-4.65-2.08-4.65-4.65c0-0.31,0.03-0.61,0.09-0.91l13.97-69.88 c0.08-0.42,0.44-0.72,0.86-0.75c0.43-0.03,0.82,0.24,0.94,0.66l7.43,24.16c0.03,0.09,0.04,0.18,0.04,0.27V60.4 C-7.68,60.91-8.09,61.33-8.61,61.33 M-15.85-10.14l-13.26,66.28c-0.3,1.51,0.68,2.98,2.19,3.28c0.18,0.04,0.36,0.05,0.54,0.05 h16.84v-49.1L-15.85-10.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_396",
    className: "st1",
    d: "M68.61,61.33H50.85c-0.51,0-0.93-0.42-0.93-0.93l0,0V10.23c0-0.09,0.01-0.18,0.04-0.27 l7.43-24.16c0.11-0.42,0.51-0.69,0.94-0.66c0.42,0.02,0.78,0.33,0.86,0.75l13.97,69.88c0.5,2.52-1.13,4.96-3.64,5.47 C69.22,61.3,68.92,61.33,68.61,61.33 M51.78,59.47h16.83c1.54,0,2.79-1.25,2.79-2.79c0-0.18-0.02-0.37-0.05-0.55L58.09-10.14 l-6.31,20.51V59.47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_397",
    className: "st1",
    d: "M-8.61,68.76h-18.58c-0.51,0-0.93-0.42-0.93-0.93c0-0.08,0.01-0.15,0.03-0.22l1.86-7.44 c0.1-0.41,0.48-0.7,0.9-0.7h16.72c0.51,0,0.93,0.42,0.93,0.93l0,0v7.43C-7.68,68.35-8.1,68.76-8.61,68.76L-8.61,68.76 M-26,66.9 h16.46v-5.57h-15.07L-26,66.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_398",
    className: "st1",
    d: "M69.43,68.76H50.85c-0.51,0-0.93-0.42-0.93-0.93l0,0V60.4c0-0.51,0.42-0.93,0.93-0.93l0,0 h16.72c0.42,0,0.79,0.29,0.9,0.7l1.86,7.43c0.12,0.5-0.18,1-0.68,1.13C69.58,68.75,69.5,68.76,69.43,68.76 M51.78,66.9h16.46 l-1.39-5.57H51.78L51.78,66.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_399",
    className: "st1",
    d: "M50.85,76.19H-8.61c-0.51,0-0.93-0.42-0.93-0.93l0,0v-7.43c0-0.51,0.42-0.93,0.93-0.93h0 h59.46c0.51,0,0.93,0.42,0.93,0.93l0,0v7.43C51.78,75.78,51.36,76.19,50.85,76.19L50.85,76.19 M-7.68,74.34h57.6v-5.57h-57.6 V74.34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_400",
    className: "st1",
    d: "M21.12-1.84c-0.15,0-0.3-0.04-0.44-0.11L-7.19-16.81c-0.4-0.21-0.59-0.68-0.44-1.11 l3.72-11.15c0.16-0.49,0.69-0.75,1.17-0.59c0.11,0.04,0.22,0.1,0.31,0.17L21.72-9.06c0.21,0.18,0.33,0.44,0.33,0.71v5.57 C22.05-2.26,21.63-1.84,21.12-1.84L21.12-1.84 M-5.62-18.09L20.19-4.32v-3.59L-2.59-27.19L-5.62-18.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_401",
    className: "st1",
    d: "M17.4,18.6c-0.51,0-0.93-0.42-0.93-0.93l0,0v-22.3c0-0.51,0.42-0.93,0.93-0.93 s0.93,0.42,0.93,0.93v22.3C18.33,18.18,17.92,18.6,17.4,18.6L17.4,18.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_402",
    className: "st1",
    d: "M24.83,18.6c-0.51,0-0.93-0.42-0.93-0.93l0,0v-22.3c0-0.51,0.42-0.93,0.93-0.93 s0.93,0.42,0.93,0.93v22.3C25.76,18.18,25.35,18.6,24.83,18.6L24.83,18.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_403",
    className: "st1",
    d: "M50.85,68.76H-8.61c-0.51,0-0.93-0.42-0.93-0.93l0,0V10.37l-7.39-24.02 c-0.14-0.46,0.09-0.96,0.54-1.14l9.3-3.72c0.25-0.1,0.54-0.08,0.78,0.04L21.12-3.83l27.43-14.63c0.24-0.13,0.53-0.14,0.78-0.04 l9.29,3.72c0.45,0.18,0.68,0.67,0.54,1.14l-7.39,24.02v57.46C51.78,68.35,51.36,68.76,50.85,68.76L50.85,68.76 M-7.68,66.9h57.6 V10.23c0-0.09,0.01-0.18,0.04-0.27l7.18-23.34l-8.09-3.24L21.56-1.95c-0.27,0.15-0.6,0.15-0.88,0L-6.81-16.61l-8.09,3.24 l7.18,23.34c0.03,0.09,0.04,0.18,0.04,0.27L-7.68,66.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_404",
    className: "st1",
    d: "M21.12-7.41c-0.22,0-0.43-0.08-0.6-0.22L-3.64-28.08c-0.39-0.33-0.44-0.92-0.11-1.31 c0.18-0.21,0.44-0.33,0.71-0.33h48.31c0.51,0,0.93,0.41,0.93,0.93c0,0.27-0.12,0.54-0.33,0.71L21.71-7.64 C21.55-7.5,21.33-7.42,21.12-7.41 M-0.5-27.86L21.12-9.56l21.62-18.29H-0.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_405",
    className: "st1",
    d: "M21.12-1.84c-0.51,0-0.93-0.41-0.93-0.92c0,0,0,0,0,0v-5.57c0-0.27,0.12-0.53,0.33-0.71 l24.15-20.44c0.39-0.33,0.98-0.28,1.31,0.11c0.08,0.09,0.14,0.2,0.17,0.31l3.72,11.15c0.14,0.43-0.04,0.9-0.44,1.11L21.56-1.95 C21.42-1.88,21.27-1.84,21.12-1.84 M22.05-7.92v3.6l25.81-13.77l-3.03-9.1L22.05-7.92z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoodTshirt);
export default __webpack_public_path__ + "static/media/hoodTshirt.bf4c4f93ea47a3a72a06cb21d86bffe4.svg";
export { ForwardRef as ReactComponent };